export default "__VITE_ASSET__BWlk$9Mg__"